import PressureSimulate from './PressureSimulate';
export default PressureSimulate;



// WEBPACK FOOTER //
// ./resources/assets/js/components/PressureSimulate/index.js